import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AddMunicipalitiesService } from '../../admin/dashboard/ministry/municipalities/add-municipalities/add-municipalities.service';


@Injectable({
  providedIn: 'root'
})
export class RegionsResolver  {
  constructor(private addMunicipulitiesService: AddMunicipalitiesService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    console.log("55555555555555555555555555555555555555");

    return this.addMunicipulitiesService.getRegions();
  }
}
